//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import kotlin.Any

public data class CompleteInspectionCommandInput(
  public val inspectionId: Any,
)
